import React from 'react';
import { PauseCircle, Clock, DollarSign } from 'lucide-react';

/**
 * Компонент секции дополнительных параметров поездки
 */
const AdditionalParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Clock className="w-5 h-5 mr-2 text-blue-500" />
        Дополнительные параметры
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Учет перерывов */}
        <div className="col-span-full">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="breaks"
              checked={formData.breaks}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Учитывать перерывы для отдыха
            </span>
          </label>
          {formData.breaks && (
            <div className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-3">
              <div>
                <label htmlFor="breakInterval" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
                  <PauseCircle className="w-4 h-4 mr-1 text-blue-500" />
                  Интервал перерыва (ч)
                </label>
                <input
                  type="text"
                  id="breakInterval"
                  name="breakInterval"
                  value={formData.breakInterval}
                  onChange={handleInputChange}
                  className={`form-input w-full ${errors.breakInterval ? 'input-error' : ''}`}
                  placeholder="Часы вождения до перерыва"
                />
                {errors.breakInterval && (
                  <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                    {errors.breakInterval}
                  </p>
                )}
              </div>
              <div>
                <label htmlFor="breakDuration" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
                  <Clock className="w-4 h-4 mr-1 text-blue-500" />
                  Длительность перерыва (мин)
                </label>
                <input
                  type="text"
                  id="breakDuration"
                  name="breakDuration"
                  value={formData.breakDuration}
                  onChange={handleInputChange}
                  className={`form-input w-full ${errors.breakDuration ? 'input-error' : ''}`}
                  placeholder="Минут на отдых"
                />
                {errors.breakDuration && (
                  <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                    {errors.breakDuration}
                  </p>
                )}
              </div>
            </div>
          )}
        </div>

        {/* Учет платных дорог */}
        <div className="col-span-full mt-2">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="tollRoads"
              checked={formData.tollRoads}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Учитывать платные дороги
            </span>
          </label>
          {formData.tollRoads && (
            <div className="mt-2">
              <label htmlFor="tollRoadsCost" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
                <DollarSign className="w-4 h-4 mr-1 text-blue-500" />
                Стоимость платных дорог (руб)
              </label>
              <input
                type="text"
                id="tollRoadsCost"
                name="tollRoadsCost"
                value={formData.tollRoadsCost}
                onChange={handleInputChange}
                className={`form-input w-full ${errors.tollRoadsCost ? 'input-error' : ''}`}
                placeholder="Общая стоимость платных участков"
              />
              {errors.tollRoadsCost && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.tollRoadsCost}
                </p>
              )}
            </div>
          )}
        </div>

        {/* Учет запланированных остановок */}
        <div className="col-span-full mt-2">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeStops"
              checked={formData.includeStops}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Учитывать запланированные остановки
            </span>
          </label>
        </div>
      </div>

      {/* Информация о стандартах безопасности */}
      <div className="mt-4 bg-blue-50 dark:bg-blue-900/30 p-3 rounded-lg border border-blue-200 dark:border-blue-800">
        <div className="flex items-start">
          <PauseCircle className="w-5 h-5 text-blue-600 dark:text-blue-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-blue-700 dark:text-blue-300 mb-1">
              Рекомендации по безопасности
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400">
              Согласно правилам безопасности, рекомендуется делать перерыв 
              каждые 2-3 часа вождения продолжительностью не менее 15 минут.
              В ночное время перерывы следует делать чаще.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdditionalParametersSection;